import { CalendarEvent, google, ics, outlook } from "calendar-link";
import ModalComponent from "..";
import { ModalCompProps } from "../../../utils/types";
import { Icon } from "../../icon/icon";

export const CalendarOptionsModal = ({
  open,
  handleClose,
  event,
}: ModalCompProps & {
  event: CalendarEvent;
}) => {
  const options = [
    {
      icon: "google",
      iconDimension: 24,
      text: "Google Calendar",
      link: google(event),
    },
    {
      icon: "apple",
      iconDimension: 24,
      text: "Apple Calendar (iCal)",
      link: ics(event),
    },
    {
      icon: "outlook",
      iconDimension: 20,
      text: "Outlook Calendar",
      link: outlook(event),
    },
  ];
  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      className="md:!max-w-[580px]"
      dialogClassName=""
      closeOnOverlayClick
      showHeader
      title="Add to Calendar"
      showMobileTopBar
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon
      closeButtonClassName="!p-0 !bg-transparent hidden md:block"
    >
      <div className="flex w-full flex-col gap-3">
        {options.map((option, idx) => {
          return (
            <a
              target="_blank"
              rel="noreferrer"
              href={option.link}
              className="flex w-full items-center gap-4 rounded-2xl bg-grey-50 p-3"
              key={`calendar-option-${idx}`}
            >
              <Icon
                svg={option.icon}
                width={option.iconDimension}
                height={option.iconDimension}
              />
              <p className="flex-1 text-sm font-bold">{option.text}</p>
              <Icon
                svg={"caret-down"}
                width={24}
                height={24}
                className="-rotate-90"
              />
            </a>
          );
        })}
      </div>
    </ModalComponent>
  );
};
